import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import papyrusBg from '@assets/images/papyrus.png';
import { useFormatVariantJson } from '@hooks';

export const ModuleHeaderText = observer(() => {
  const { getFormattedText } = useFormatVariantJson();
  const description = getFormattedText('description');

  if (!description) return <></>;

  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(to left, #44accd 0%, #1568a0 100%), url(${papyrusBg})`,
        backgroundBlendMode: 'multiply',
        borderRadius: 2,
        px: 1.5,
        py: 2,
        color: 'white',
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 1.2,
        }}
        component="div"
      >
        {getFormattedText('description')}
      </Typography>
    </Box>
  );
});
